import React from 'react'
import PropTypes from 'prop-types'
import ComposeExtraButton from './compose_extra_button'

const SpoilerButton = ({ small, spoiler, onSpoiler }) => (
  <ComposeExtraButton
    title='Warning'
    icon="warning"
    onClick={onSpoiler}
    small={small}
    active={spoiler}
    iconClassName={_s.cIconComposeSpoiler}
  />
)


SpoilerButton.propTypes = {
  small: PropTypes.bool,
  spoiler: PropTypes.bool,
  onSpoiler: PropTypes.func
}

export default SpoilerButton
